module.exports = __webpack_public_path__ + "img/bq.94749032.png";